import * as angular from 'angular';
import FdxTransformersFaqModalController from './fdx-transformers-faq-modal.controller';
import { MODULE_NAME } from '../../../../config/constants';

import './fdx-transformers-faq-modal.styles.scss';

export const componentName = 'fdxTransformersFaqModal';

angular.module(MODULE_NAME).component(componentName, {
	template: require('./fdx-transformers-faq-modal.template.html'),
	controller: FdxTransformersFaqModalController,
	bindings: {
		// from uibmodal
		close: '&',
		dismiss: '&',
		resolve: '<?'
	}
});
